var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", { attrs: { "no-sidebar": true } }, [
    _c("div", { staticClass: "page-header" }, [
      _c("h1", [_c("small", [_vm._v("User Profile")])])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-3" }, [
        _c("ul", { staticClass: "nav nav-pills nav-stacked" }, [
          _c(
            "li",
            {
              class: { active: _vm.$route.name === "profile.personalInfo" },
              attrs: { role: "presentation" }
            },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "profile.personalInfo" } } },
                [_vm._v("\n            Personal Info\n          ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.$route.name === "profile.security" },
              attrs: { role: "presentation" }
            },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "profile.security" } } },
                [_vm._v("\n            Security\n          ")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [_c("router-view")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daa019d0", { render: render, staticRenderFns: staticRenderFns })
  }
}